export const channels = [
  {
    name: 'Key Metrics By Expert',
    value: 'key-metrics-by-expert',
    enabled: true
  },
  {
    name: 'Key Metrics',
    value: 'key-metrics',
    enabled: true
  }
];
